import React from "react";
import {FIELD_TYPE} from "../../../Type/Model/Model";
import {CustomCheckbox} from "../../../../../../components/CustomCheckbox";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

export const CommonDocumentationFormApp  = () => {

    const getBaseProps = (field, emptyFields) => {
        return {
            id: `${[field.fieldType]}_${field.fieldId}`,
            name: field.fieldName,
            required: field.required,
            ...(field.required && { emptyFields }),
        };
    }

    const fieldsFormCheckBox = (field, data, handleChange, emptyFields) => {
        if (field.fieldType !== FIELD_TYPE.CHECKBOX.name) return null;
        const base = getBaseProps(field, emptyFields);
        const value = String(data[field.fieldId]?.value) === 'true' ?? false;

        return (
            <CustomCheckbox
                {...base}
                trans={field.fieldName}
                checked={value}
                onChange={e => handleChange(field, e.target.checked)}
                marginbutton={true}
            />
        )

    };

    return {
        getBaseProps,
        fieldsFormCheckBox
    };
}
